/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum PncStatusColorEnum {
    UNKNOWN = 'UNKNOWN',
    BACKGROUND_COLOR = 'BACKGROUND_COLOR',
    CREATION = 'CREATION',
    PENDING = 'PENDING',
    ANALYSIS = 'ANALYSIS',
    REJECTED = 'REJECTED',
    SOLVED = 'SOLVED',
    CANCELLED = 'CANCELLED',
}
